


























































































































































































// Vue
import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

// Constants
import Assets from '@/constants/assets';
import RouteNames from '@/constants/route-names';

// Components
import Avatar, {
  AvatarSize,
  AvatarColorOverlay,
} from '@/shared/components/Avatar.component.vue';
import Btn, {
  BtnWidth,
  BtnColor,
} from '@/shared/components/btn.component.vue';
import Icon, { IconEnum } from '@/shared/components/icon.component.vue';

// Service
import UtilsService from '@/core/services/utils.service';

@Component({
  components: {
    Avatar,
    Btn,
    Icon,
  },
  computed: {
    ...mapGetters({
      profile: 'getProfile',
      navBarIsOpen: 'isOpenNavbar',
    }),
  },
})
export default class MainNavBar extends Vue {
  private assets = Assets;
  private routeNames = RouteNames;
  private btnColor = BtnColor;
  private btnWidth = BtnWidth;
  private avatarSize = AvatarSize;
  private avatarColorOverlay = AvatarColorOverlay;
  private iconEnum = IconEnum;
  private utilsService = UtilsService;
  private profile!: any;
  private navBarIsOpen!: boolean;
  private userWebPermissions!:any;
  private menu = {
    product: false,
    employee: false,
    client: false,
    convocation: false,
    purchase: false,
    sync: false,
    budget: false,
    billing: false,
    settings: false,
    backoffice: false,
    styleGuide: false
  }
  private inDebug: boolean = UtilsService.inDebug();

  get backgroundImg() {
    this.userPermissions()
    return {
      'background-image': this.inDebug ? `url("${this.assets.navbarBgTest}")` : `url("${this.assets.navbarBg}")`,
      'background-repeat': 'no-repeat',
      'background-position': 'center bottom',
    };
  }

  get profileAvatar() {
    let result = Assets.defaultAvatar;
    if ( Object.keys(this.profile).length === 0 && this.profile.constructor === Object ) {
      this.$store.dispatch('fetchProfile');
    } else if ( this.profile.profile !== null && this.profile.profile.avatar !== null ) {
      result = this.profile.profile.avatar;
    }
    return result;
  }

  private toggleNavBar() {
    const newNavBarIsOpen = !this.navBarIsOpen;
    this.$store.dispatch('setOpenNavbar', newNavBarIsOpen);
  }

  private logout() {
    this.$store.dispatch('authLogout')
    .then(() => {
      this.$router.push('/login');
    });
  }

  private userPermissions(){
    this.$store.dispatch('fetchuserPermissions')
    .then((res) => {
      this.userWebPermissions = res
      this.setMenu()
    });
  }

  get showStyleGuide(): boolean {
    return this.utilsService.inDebug();
  }

  get showBackoffice(): boolean {
    return this.profile.isStaff;
  }

  get showSync(): boolean {
    return this.isAdministrator();
  }

  get showBudget(): boolean {
    return this.isAdministrator();
  }

  get showBilling(): boolean {
    return this.isAdministrator();
  }

  private setMenu() {
    
    // return {
    //   product: false,
    //   employee: false,
    //   client: true,
    //   convocation: true,
    //   purchase: true,
    //   sync: this.showSync,
    //   budget: this.showBudget,
    //   billing: this.showBilling,
    //   settings: false,
    //   backoffice: this.showBackoffice,
    // };
    this.menu = {
      product: false,
      employee: false,
      client: this.userWebPermissions.usersPermission,
      convocation: this.userWebPermissions.convocationPermission,
      purchase: this.userWebPermissions.purchasePermission,
      sync: this.userWebPermissions.syncPermission,
      budget: this.userWebPermissions.budgetPermission,
      billing: this.userWebPermissions.billPermission,
      settings: false,
      backoffice: this.userWebPermissions.backofficePermission,
      styleGuide: this.userWebPermissions.styleGuidePermission,
    };
  }

  private isAdministrator(): boolean {
    return (this.profile.employee !== undefined &&
      this.profile.employee.department !== null &&
      this.profile.employee.department.name === 'Administración');
  }
}
